import {
  initialTrackingState,
  createTrackingSlice,
  TrackingStatus,
  ITrackingSlice,
} from "app/TrackingSlice";
import { Track } from "model/Track/Track";

const initialState: ITrackSlice = {
  ...initialTrackingState,
};

export const trackSlice = createTrackingSlice(
  {
    name: "track",
    initialState,
    reducers: {},
  },
  (status) => status,
  (status: TrackingStatus) => {
    return status;
  }
);

export interface ITrackSlice extends ITrackingSlice<Track, TrackingStatus> {}
export const { track: trackTracks, update: updateTrack } = trackSlice.actions;
export const trackReducer = trackSlice.reducer;
